const variablesByEnvironments: {
  [key: string]: {
    urlApiPlataforma: string;
    urlApiCadastro: string;
    urlApiGateway: string;
    urlApiWorkflowIntegracao?: string;
    urlApiIntegracao?: string;
    helpdeskUrl?: string;
    subPath?: string;
    ambiente: string;
  };
} = {
  topocartDev: {
    urlApiPlataforma: "https://api.topocart.dev.br/plataforma",
    urlApiCadastro: "https://api.topocart.dev.br/cadastro",    
    urlApiGateway: "https://api.topocart.dev.br/gateway",
    urlApiWorkflowIntegracao: "https://workflows.desenvolvimento.topocart.dev.br/webhook",
    urlApiIntegracao: "https://integracao-api.desenvolvimento.topocart.dev.br",
    subPath: "/",
    ambiente: "Ambiente de Desenvolvimento - Topocart",
  },
  portoVelho: {
    urlApiPlataforma: "https://plataforma-geo360.portovelho.ro.gov.br",
    urlApiCadastro: "https://cadastro-geo360.portovelho.ro.gov.br",
    urlApiGateway: "https://gateway-geo360.portovelho.ro.gov.br",
    subPath: "/",
    ambiente: "Porto Velho",
  },
  alexania: {
    urlApiPlataforma: "https://plataforma-geo360.alexania.go.gov.br",
    urlApiCadastro: "https://cadastro-geo360.alexania.go.gov.br",
    urlApiGateway: "https://gateway-geo360.alexania.go.gov.br",
    subPath: "/",
    ambiente: "Alexania",
  },
  goiania: {
    urlApiPlataforma: "https://apis-goiania.geo360.com.br/plataforma",
    urlApiCadastro: "https://apis-goiania.geo360.com.br/cadastro",
    urlApiGateway: "https://apis-goiania.geo360.com.br/openrest",
    subPath: "/caracterizacao/",
    ambiente: "Goiania",
  },
  manaus: {
    urlApiPlataforma: "https://plataforma-geo360.manaus.am.gov.br",
    urlApiCadastro: "https://cadastro-geo360.manaus.am.gov.br",
    urlApiGateway: "https://gateway-geo360.manaus.am.gov.br",
    subPath: "/",
    ambiente: "Manaus",
  },
  next: {
    urlApiPlataforma: "https://plataforma.geo360.dev",
    urlApiCadastro: "https://cadastro.geo360.dev",
    urlApiGateway: "https://gateway.geo360.dev",
    subPath: "/",
    ambiente: "Ambiente de Homologação",
  },
  mesquita: {
    urlApiPlataforma: "https://plataforma.geo360.com.br",
    urlApiCadastro: "https://cadastro.geo360.com.br",
    urlApiGateway: "https://api-gateway.geo360.com.br",
    urlApiWorkflowIntegracao: "https://workflows-integracao.topocart.dev.br/webhook",
    urlApiIntegracao: "https://integracao-api.topocart.dev.br",
    subPath: "/",
    ambiente: "eTopocart",
  },
};

type EnvironmentConfig = (typeof variablesByEnvironments)[string];

function resolveEnvironmentConfig(): EnvironmentConfig {
  const key = process.env.REACT_APP_AMBIENTE || "topocartDev";
  const base = variablesByEnvironments[key] ?? variablesByEnvironments.topocartDev;

  return {
    ...base,
    urlApiPlataforma: process.env.REACT_APP_URL_API_PLATAFORMA || base.urlApiPlataforma,
    urlApiCadastro: process.env.REACT_APP_URL_API_CADASTRO || base.urlApiCadastro,
    urlApiGateway: process.env.REACT_APP_URL_API_GATEWAY || base.urlApiGateway,
  };
}

export const environments = resolveEnvironmentConfig();
export const sinterHelpdeskUrl = process.env.REACT_APP_SINTER_HELPDESK_URL || environments.helpdeskUrl || "https://helpdesk.geo360.com.br";
export const socketToken = process.env.REACT_APP_SOCKET_TOKEN
